import { useAppConfig } from '../../hooks/useAppConfig';

export default function Gallery() {
  const appConfig = useAppConfig();
  const wallpapers = appConfig.galleryWallpapers;

  return (
    <section id="gallery" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Stunning <span 
              className="bg-gradient-to-r bg-clip-text text-transparent"
              style={{
                backgroundImage: `linear-gradient(to right, ${appConfig.primaryColor}, ${appConfig.secondaryColor})`
              }}
            >
              Wallpaper
            </span> Collection
          </h3>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our curated selection of premium 4K wallpapers across various categories
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12">
          {wallpapers.map((wallpaper) => (
            <div key={wallpaper.id} className="group flex flex-col items-center">
              {/* Mobile Mockup */}
              <div className="relative transform hover:scale-105 transition-transform duration-300">
                <div className="w-24 h-48 sm:w-32 sm:h-64 lg:w-48 lg:h-96 bg-black rounded-xl sm:rounded-2xl lg:rounded-[2.5rem] p-1 sm:p-1.5 lg:p-2 shadow-2xl">
                  <div className="w-full h-full bg-white rounded-lg sm:rounded-xl lg:rounded-[2rem] overflow-hidden relative">
                    <img 
                      src={wallpaper.image}
                      alt={wallpaper.title}
                      className="w-full h-full object-cover"
                    />
                    {/* Phone notch */}
                    <div className="absolute top-1 sm:top-2 lg:top-3 left-1/2 transform -translate-x-1/2 w-6 h-1.5 sm:w-8 sm:h-2 lg:w-16 lg:h-4 bg-black rounded-full"></div>
                    
                    {/* Overlay with category and likes */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-2 sm:bottom-3 lg:bottom-4 left-2 sm:left-3 lg:left-4 right-2 sm:right-3 lg:right-4">
                        <div className="flex items-center justify-between text-white">
                          <span className="bg-white/20 backdrop-blur-sm px-1.5 py-0.5 sm:px-2 sm:py-1 lg:px-3 lg:py-1 rounded-full text-xs sm:text-xs lg:text-xs font-medium">
                            {wallpaper.category}
                          </span>
                          <div className="flex items-center space-x-1">
                            <i className="ri-heart-line text-red-400 text-xs sm:text-sm"></i>
                            <span className="text-xs hidden sm:inline">{wallpaper.likes.toLocaleString()}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Download button */}
                    <div className="absolute top-2 sm:top-4 lg:top-8 right-1 sm:right-2 lg:right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <button className="w-4 h-4 sm:w-6 sm:h-6 lg:w-8 lg:h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors cursor-pointer">
                        <i className="ri-download-line text-xs sm:text-xs lg:text-sm"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Category label below mockup */}
              <div className="mt-2 sm:mt-3 lg:mt-4 text-center">
                <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 mb-1">{wallpaper.category}</h4>
                <div className="flex items-center justify-center space-x-1 sm:space-x-2 text-gray-600">
                  <i className="ri-heart-line text-red-400 text-xs sm:text-sm"></i>
                  <span className="text-xs sm:text-sm">{wallpaper.likes.toLocaleString()} likes</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <p className="text-sm sm:text-base text-gray-600">
            Download the app to explore thousands more wallpapers!
          </p>
        </div>
      </div>
    </section>
  );
}
